import { Injectable } from '@angular/core';

import { ExportCheck } from 'src/app/_utils/check-export';
import { ExportChecker } from './validate-json.component';

// Kept out of the page's file: Jest can't load import.meta, so the page's tests never import this
/** Checks exports in a web worker, one at a time, so a 50 MB file doesn't freeze the page */
@Injectable()
export class WorkerExportChecker implements ExportChecker {
  private worker: Worker | null = null;

  check(name: string, file: File) {
    return new Promise<ExportCheck>(resolve => {
      this.worker ??= new Worker(new URL('./validate-json.worker', import.meta.url), { type: 'module' });
      this.worker.onmessage = ({ data }: MessageEvent<ExportCheck>) => resolve(data);
      this.worker.postMessage({ name, file });
    });
  }

  stop() {
    this.worker?.terminate();
    this.worker = null;
  }
}
